<div class="modal fade" data-backdrop="static" data-keyboard="false" id="strategyDetailsModal" tabindex="-1" role="dialog" aria-labelledby="strategyModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div class="row flex-fill">
                    <div class="col-md-10">
                        <h5>{{ strategyParams.header }}</h5>
                    </div>
                    <div class="col-md-1 px-0 enable-margin">
                        <div class="form-check form-switch" *ngIf="strategyParams.show_status">
                            <input class="form-check-input enable-size shadow-none" type="checkbox" id="flexSwitchCheckDefault" [checked]="strategyParams.enabled">
                        </div>
                    </div>
                    <div class="col-md-1">
                        <button type="button" class="btn-close close-button" aria-label="Close" (click)="closeModal(strategyParams)"></button>
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <div class="row sub-header-buffer">
                    <div class="col-md-6">
                        <label class="form-label">Name</label>
                        <div class="form-group">
                            <select id="name" class="form-select shadow-none" [(ngModel)]="strategyParams.strategy_name" [disabled]="edit" (change)="onStrategySelected()">
                                <option *ngFor="let s of strategies" [disabled]="s.disabled" [value]="s.name"> {{ s.display_name }}</option>
                            </select>
                            <!-- <label for="name">Name</label> -->
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Broker</label>
                        <div class="form-group">
                            <select class="form-select shadow-none" [(ngModel)]="strategyParams.ba_name">
                                <option *ngFor="let ba of bas" [value]="ba.name"> {{ ba.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <strategy-wrapper></strategy-wrapper>
                <!-- <div *ngIf="strategyParams.code == 'lss_v2'">
                    <div class="row sub-header-buffer">
                        <div class="col-md-6">
                            <label class="form-label">Name</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.strategy_name" (change)="onStrategySelected()">
                                <option *ngFor="let s of strategies" [value]="s.name"> {{ s.display_name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Broker</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.ba_name">
                                    <option *ngFor="let ba of bas" [value]="ba.name"> {{ ba.name }}</option>
                                </select>
                            </div>
                        </div>

                    </div>
                    <div class="row mt-2">
                        <div class="col-md-3">
                            <label class="form-label">Exchange</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.exchange" disabled="true">
                                    <option *ngFor="let e of exchanges" [value]="e.name"> {{ e.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Segment</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.segment" disabled="true">
                                    <option *ngFor="let s of segments" [value]="s.name"> {{ s.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label"> Symbol</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.symbol">
                                    <option *ngFor="let sym of symbols" [value]="sym.name"> {{ sym.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="form-label">Entry Time</label>
                            <div class="form-group">
                                <input type="time" class="form-control" autocomplete="off" [(ngModel)]="strategyParams.entry_time">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Exit Time</label>
                            <div class="form-group">
                                <input type="time" class="form-control" autocomplete="off" [(ngModel)]="strategyParams.exit_time">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 ml-auto">
                            <label class="form-label"></label>
                            <div class="form-group">
                                <div class="btn-group">
                                    <button class="btn btn-xs border border-info" [ngClass]="modeClass(strategyParams, 'dry_run')" data-toggle="collapse" data-target="#collapsible" (click)="onModeSelect(strategyParams, 'dry_run')">Dryrun</button>
                                    <button class="btn btn-xs border border-success" [ngClass]="modeClass(strategyParams, 'live')" data-toggle="collapse" data-target="#collapsible" (click)="onModeSelect(strategyParams, 'live')">Live</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"></label>
                            <div class="form-group">
                                <div class="btn-group btn-toggle mb-2">
                                    <button class="btn btn-xs border border-success" [ngClass]="ttClass(strategyParams, 'buy')" data-toggle="collapse" data-target="#collapsible" (click)="onTTSelect(strategyParams, 'buy')">Buy</button>
                                    <button class="btn btn-xs border border-danger" [ngClass]="ttClass(strategyParams, 'sell')" data-toggle="collapse" data-target="#collapsible" (click)="onTTSelect(strategyParams, 'sell')">Sell</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"></label>
                            <div class="form-group">
                                <div class="btn-group btn-toggle mb-2">
                                    <button class="btn btn-xs border border-info" [ngClass]="ptClass(strategyParams, 'mis')" data-toggle="collapse" data-target="#collapsible" (click)="onPTSelect(strategyParams, 'mis')">MIS</button>
                                    <button class="btn btn-xs border border-info" [ngClass]="ptClass(strategyParams, 'nrml')" data-toggle="collapse" data-target="#collapsible" (click)="onPTSelect(strategyParams, 'nrml')">NRML</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-4">
                            <label class="form-label">Interval</label>
                            <div class="form-group">
                                <div class="form-group">
                                    <select class="form-select" [(ngModel)]="strategyParams.interval.name">
                                        <option *ngFor="let i of intervals" [value]="i.name"> {{ i.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Lots</label>
                            <div class="form-group">
                                <input type="number" step=1 class="form-control" [(ngModel)]="strategyParams.lots">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Target</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.tgt.type" (change)="onLssV2TgtTypeSelected()">
                                    <option *ngFor="let sl_tgt of lss_v2_sl_tgts" [value]="sl_tgt._id"> 
                                        {{ sl_tgt.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Value</label>
                            <div class="form-group">
                                <input type="number" [disabled]="strategyParams.tgt.disabled" step="1" min="1" max="100000" class="form-control" [(ngModel)]="strategyParams.tgt.value">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-4">
                            <label class="form-label">SL</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.sl.type" (change)="onLssV2SLTypeSelected()">
                                    <option *ngFor="let sl_tgt of lss_v2_sl_tgts" [value]="sl_tgt._id"> 
                                        {{ sl_tgt.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Value</label>
                            <div class="form-group">
                                <input type="number" [disabled]="strategyParams.sl.disabled" step="1" min="1" max="100000" class="form-control" [(ngModel)]="strategyParams.sl.value">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">TSL Range(%)</label>
                            <div class="form-group">
                                <input type="number" step="1" min="0" max="100" class="form-control" [(ngModel)]="strategyParams.tsl_range">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">TSL Value(%)</label>
                            <div class="form-group">
                                <input type="number" step="1" min="0" max="100" class="form-control" [(ngModel)]="strategyParams.tsl_value">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-4">
                            <label class="form-label">Cover SL</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.cover_sl.type" (change)="onLssV2CoverSLTypeSelected()">
                                    <option *ngFor="let sl_tgt of lss_v2_sl_tgts" [value]="sl_tgt._id"> 
                                        {{ sl_tgt.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Value</label>
                            <div class="form-group">
                                <input type="number" [disabled]="strategyParams.cover_sl.disabled" step="1" min="1" max="100000" class="form-control" [(ngModel)]="strategyParams.cover_sl.value">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Expiry</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.expiry_selection.type">
                                    <option *ngFor="let exp_type of exp_types" [value]="exp_type._id"> 
                                        {{ exp_type.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Order Type</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.order_type">
                                    <option *ngFor="let order_type of order_types" [value]="order_type._id"> 
                                        {{ order_type.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-4">
                            <label class="form-label">Combined SL</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.combined_sl.type" (change)="onLssV2CombinedSLTypeSelected()">
                                    <option *ngFor="let sl_tgt of lss_v2_sl_tgts" [value]="sl_tgt._id"> 
                                        {{ sl_tgt.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Value</label>
                            <div class="form-group">
                                <input type="number" [disabled]="strategyParams.combined_sl.disabled" step="1" min="1" max="100000" class="form-control" [(ngModel)]="strategyParams.combined_sl.value">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Combined Target</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.combined_tgt.type" (change)="onLssV2CombinedTgtTypeSelected()">
                                    <option *ngFor="let sl_tgt of lss_v2_sl_tgts" [value]="sl_tgt._id"> 
                                        {{ sl_tgt.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Value</label>
                            <div class="form-group">
                                <input type="number" [disabled]="strategyParams.combined_tgt.disabled" step="1" min="1" max="100000" class="form-control" [(ngModel)]="strategyParams.combined_tgt.value">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="form-label">&nbsp;</label>
                            <div class="form-group">
                                <div class="btn-group btn-toggle mb-2">
                                    <button class="btn btn-xs border border-info" [ngClass]="ssClass(strategyParams, 'default')" data-toggle="collapse" data-target="#collapsible" (click)="onSSSelect(strategyParams, 'default')">ATM</button>
                                    <button class="btn btn-xs border border-info" [ngClass]="ssClass(strategyParams, 'premium')" data-toggle="collapse" data-target="#collapsible" (click)="onSSSelect(strategyParams, 'premium')">Premium</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">ATM +/-</label>
                            <div class="form-group">
                                <input type="number" [disabled]="strategyParams.ss != 'default'" [step]="strategyParams.strike_diff" max="2000" class="form-control" [(ngModel)]="strategyParams.strike_range">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Premium</label>
                            <div class="form-group">
                                <input type="number" [disabled]="strategyParams.ss != 'premium'" step="1" min="5" max="2000" class="form-control" [(ngModel)]="strategyParams.premium">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="form-label">&nbsp;</label>
                            <div class="form-group">
                                <div class="btn-group btn-toggle mb-2">
                                    <button class="btn btn-xs border border-info" [ngClass]="reenterClass(strategyParams, 'no')" data-toggle="collapse" data-target="#collapsible" (click)="onReenterSelect(strategyParams, 'no')">No</button>
                                    <button class="btn btn-xs border border-info" [ngClass]="reenterClass(strategyParams, 'reenter')" data-toggle="collapse" data-target="#collapsible" (click)="onReenterSelect(strategyParams, 'reenter')">Reenter</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">On</label>
                            <div class="form-group">
                                <select class="form-select" [disabled]="strategyParams.reenter.state != 'enabled'" [(ngModel)]="strategyParams.reenter.on" (change)="onReenterOnSelected()">
                                    <option *ngFor="let re_type of re_types" [value]="re_type._id"> 
                                        {{ re_type.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Count</label>
                            <div class="form-group">
                                <input type="number" [disabled]="strategyParams.reenter.state != 'enabled'" step="1" min="-1" max="2000" class="form-control" [(ngModel)]="strategyParams.reenter.count">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label class="form-label">&nbsp;</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-auto" *ngFor="let d of days">
                            <div class="input-group flex-nowrap">
                                <div class="input-group-prepend">
                                    <div class="input-group-text d-block p-1 border-0 bg-white">
                                        <input type="checkbox" aria-label="Checkbox for days" [(ngModel)]="strategyParams.days[d]">
                                    </div>
                                </div>
                                <span class="input-group-text flex-nowrap p-1 border-0 bg-white" id="">{{ d }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label class="form-label">&nbsp;</label>
                        </div>
                    </div>
                </div> -->
                <!-- <div *ngIf="strategyParams.code == 'adj_lss_v1'">
                    <div class="row sub-header-buffer">
                        <div class="col-md-6">
                            <label class="form-label">Name</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.strategy_name">
                                <option *ngFor="let s of strategies" [value]="s.name"> {{ s.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Broker</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.ba_name">
                                    <option *ngFor="let ba of bas" [value]="ba.name"> {{ ba.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-3">
                            <label class="form-label">Exchange</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.exchange" disabled="true">
                                    <option *ngFor="let e of exchanges" [value]="e.name"> {{ e.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Segment</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.segment" disabled="true">
                                    <option *ngFor="let s of segments" [value]="s.name"> {{ s.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label"> Symbol</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.symbol">
                                    <option *ngFor="let sym of symbols" [value]="sym.name"> {{ sym.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="form-label">Entry Time</label>
                            <div class="form-group">
                                <input type="time" class="form-control" autocomplete="off" [(ngModel)]="strategyParams.entry_time">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Exit Time</label>
                            <div class="form-group">
                                <input type="time" class="form-control" autocomplete="off" [(ngModel)]="strategyParams.exit_time">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            <label class="form-label">&nbsp;</label>
                            <div class="form-group">
                                <label class="switch">
                                    <input type="checkbox" class="switch-input" [(ngModel)]="strategyParams.enabled">
                                    <span class="switch-label" data-on="Enable" data-off="Disable"></span>
                                    <span class="switch-handle"></span>
                                </label>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"></label>
                            <div class="form-group">
                                <div class="btn-group">
                                    <button class="btn btn-xs border border-info" [ngClass]="modeClass(strategyParams, 'dry_run')" data-toggle="collapse" data-target="#collapsible" (click)="onModeSelect(strategyParams, 'dry_run')">Dryrun</button>
                                    <button class="btn btn-xs border border-success" [ngClass]="modeClass(strategyParams, 'live')" data-toggle="collapse" data-target="#collapsible" (click)="onModeSelect(strategyParams, 'live')">Live</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label"></label>
                            <div class="form-group">
                                <div class="btn-group btn-toggle mb-2">
                                    <button class="btn btn-xs border border-success" [ngClass]="ttClass(strategyParams, 'buy')" data-toggle="collapse" data-target="#collapsible" (click)="onTTSelect(strategyParams, 'buy')">Buy</button>
                                    <button class="btn btn-xs border border-danger" [ngClass]="ttClass(strategyParams, 'sell')" data-toggle="collapse" data-target="#collapsible" (click)="onTTSelect(strategyParams, 'sell')">Sell</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label"></label>
                            <div class="form-group">
                                <div class="btn-group btn-toggle mb-2">
                                    <button class="btn btn-xs border border-info" [ngClass]="ptClass(strategyParams, 'mis')" data-toggle="collapse" data-target="#collapsible" (click)="onPTSelect(strategyParams, 'mis')">MIS</button>
                                    <button class="btn btn-xs border border-info" [ngClass]="ptClass(strategyParams, 'nrml')" data-toggle="collapse" data-target="#collapsible" (click)="onPTSelect(strategyParams, 'nrml')">NRML</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="form-label">Interval</label>
                            <div class="form-group">
                                <div class="form-group">
                                    <select class="form-select" [(ngModel)]="strategyParams.interval.name">
                                        <option *ngFor="let i of intervals" [value]="i.name"> {{ i.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Lots</label>
                            <div class="form-group">
                                <input type="number" step=1 class="form-control" [(ngModel)]="strategyParams.lots">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="form-label">SL</label>
                            <div class="form-group">
                                <input type="number" step="1" min="0" max="100" class="form-control" [(ngModel)]="strategyParams.sl">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Target</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.tgt.type" (change)="onTgtTypeSelected()">
                                    <option *ngFor="let tgt of tgts" [value]="tgt._id"> 
                                        {{ tgt.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Value(%)</label>
                            <div class="form-group">
                                <input type="number" [disabled]="strategyParams.tgt.disabled" step="1" min="1" max="100000" class="form-control" [(ngModel)]="strategyParams.tgt.value">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label class="form-label">&nbsp;</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-auto" *ngFor="let d of days">
                            <div class="input-group flex-nowrap">
                                <div class="input-group-prepend">
                                    <div class="input-group-text d-block p-1 border-0 bg-white">
                                        <input type="checkbox" aria-label="Checkbox for days" [(ngModel)]="strategyParams.days[d]">
                                    </div>
                                </div>
                                <span class="input-group-text flex-nowrap p-1 border-0 bg-white" id="">{{ d }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label class="form-label">&nbsp;</label>
                        </div>
                    </div>
                </div> -->
                <!-- <div *ngIf="['hlb_v1', 'hlb_v2'].indexOf(strategyParams.code) > -1">
                    <div class="row sub-header-buffer">
                        <div class="col-md-6">
                            <label class="form-label">Name</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.strategy_name" (change)="onStrategySelected()">
                                <option *ngFor="let s of strategies" [value]="s.name"> {{ s.display_name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Broker</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.ba_name">
                                    <option *ngFor="let ba of bas" [value]="ba.name"> {{ ba.name }}</option>
                                </select>
                            </div>
                        </div>

                    </div>
                    <div class="row mt-2">
                        <div class="col-md-3">
                            <label class="form-label">Exchange</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.exchange" disabled="true">
                                    <option *ngFor="let e of exchanges" [value]="e.name"> {{ e.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Segment</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.segment" disabled="true">
                                    <option *ngFor="let s of segments" [value]="s.name"> {{ s.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label"> Symbol</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.symbol">
                                    <option *ngFor="let sym of symbols" [value]="sym.name"> {{ sym.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="form-label">Entry Time</label>
                            <div class="form-group">
                                <input type="time" class="form-control" autocomplete="off" [(ngModel)]="strategyParams.entry_time">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Exit Time</label>
                            <div class="form-group">
                                <input type="time" class="form-control" autocomplete="off" [(ngModel)]="strategyParams.exit_time">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 ml-auto">
                            <label class="form-label"></label>
                            <div class="form-group">
                                <div class="btn-group">
                                    <button class="btn btn-xs border border-info" [ngClass]="modeClass(strategyParams, 'dry_run')" data-toggle="collapse" data-target="#collapsible" (click)="onModeSelect(strategyParams, 'dry_run')">Dryrun</button>
                                    <button class="btn btn-xs border border-success" [ngClass]="modeClass(strategyParams, 'live')" data-toggle="collapse" data-target="#collapsible" (click)="onModeSelect(strategyParams, 'live')">Live</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"></label>
                            <div class="form-group">
                                <div class="btn-group btn-toggle mb-2">
                                    <button class="btn btn-xs border border-success" [ngClass]="ttClass(strategyParams, 'buy')" data-toggle="collapse" data-target="#collapsible" (click)="onTTSelect(strategyParams, 'buy')">Buy</button>
                                    <button class="btn btn-xs border border-danger" [ngClass]="ttClass(strategyParams, 'sell')" data-toggle="collapse" data-target="#collapsible" (click)="onTTSelect(strategyParams, 'sell')">Sell</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"></label>
                            <div class="form-group">
                                <div class="btn-group btn-toggle mb-2">
                                    <button class="btn btn-xs border border-info" [ngClass]="ptClass(strategyParams, 'mis')" data-toggle="collapse" data-target="#collapsible" (click)="onPTSelect(strategyParams, 'mis')">MIS</button>
                                    <button class="btn btn-xs border border-info" [ngClass]="ptClass(strategyParams, 'nrml')" data-toggle="collapse" data-target="#collapsible" (click)="onPTSelect(strategyParams, 'nrml')">NRML</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-4">
                            <label class="form-label">Interval</label>
                            <div class="form-group">
                                <div class="form-group">
                                    <select class="form-select" [(ngModel)]="strategyParams.interval.name">
                                        <option *ngFor="let i of intervals" [value]="i.name"> {{ i.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Lots</label>
                            <div class="form-group">
                                <input type="number" step=1 class="form-control" [(ngModel)]="strategyParams.lots">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Tgt Type</label>
                            <div class="form-group">
                                <select class="form-select" [(ngModel)]="strategyParams.tgt.type" (change)="onTgtTypeSelected()">
                                    <option *ngFor="let tgt of tgts" [value]="tgt._id"> 
                                        {{ tgt.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Value(%)</label>
                            <div class="form-group">
                                <input type="number" [disabled]="strategyParams.tgt.disabled" step="1" min="1" max="100000" class="form-control" [(ngModel)]="strategyParams.tgt.value">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="form-label">SL</label>
                            <div class="form-group">
                                <input type="number" step=1 class="form-control" [(ngModel)]="strategyParams.sl">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">TSL Range(%)</label>
                            <div class="form-group">
                                <input type="number" step="1" min="0" max="100" class="form-control" [(ngModel)]="strategyParams.tsl_range">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">TSL Value(%)</label>
                            <div class="form-group">
                                <input type="number" step="1" min="0" max="100" class="form-control" [(ngModel)]="strategyParams.tsl_value">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <label class="form-label">&nbsp;</label>
                            <div class="form-group">
                                <div class="btn-group btn-toggle mb-2">
                                    <button class="btn btn-xs border border-info" [ngClass]="ssClass(strategyParams, 'default')" data-toggle="collapse" data-target="#collapsible" (click)="onSSSelect(strategyParams, 'default')">ATM</button>
                                    <button class="btn btn-xs border border-info" [ngClass]="ssClass(strategyParams, 'premium')" data-toggle="collapse" data-target="#collapsible" (click)="onSSSelect(strategyParams, 'premium')">Premium</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">ATM +/-</label>
                            <div class="form-group">
                                <input type="number" [disabled]="strategyParams.ss != 'default'" [step]="strategyParams.strike_diff" max="2000" class="form-control" [(ngModel)]="strategyParams.strike_range">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Premium</label>
                            <div class="form-group">
                                <input type="number" [disabled]="strategyParams.ss != 'premium'" step="1" min="5" max="2000" class="form-control" [(ngModel)]="strategyParams.premium">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2" *ngIf="strategyParams.show_reentry">
                        <div class="col-md-6">
                            <label class="form-label">&nbsp;</label>
                            <div class="form-group">
                                <div class="btn-group btn-toggle mb-2">
                                    <button class="btn btn-xs border border-info" [ngClass]="reenterClass(strategyParams, 'no')" data-toggle="collapse" data-target="#collapsible" (click)="onReenterSelect(strategyParams, 'no')">No</button>
                                    <button class="btn btn-xs border border-info" [ngClass]="reenterClass(strategyParams, 'reenter')" data-toggle="collapse" data-target="#collapsible" (click)="onReenterSelect(strategyParams, 'reenter')">Reenter</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">On</label>
                            <div class="form-group">
                                <select class="form-select" [disabled]="strategyParams.reenter.state != 'enabled'" [(ngModel)]="strategyParams.reenter.on" (change)="onReenterOnSelected()">
                                    <option *ngFor="let re_type of re_types" [value]="re_type._id"> 
                                        {{ re_type.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Count</label>
                            <div class="form-group">
                                <input type="number" [disabled]="strategyParams.reenter.state != 'enabled'" step="1" min="-1" max="2000" class="form-control" [(ngModel)]="strategyParams.reenter.count">
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="strategyParams.show_re_d_divider">
                        <div class="col-md-12">
                            <label class="form-label">&nbsp;</label>
                        </div>
                    </div>
                    <div class="row" *ngIf="strategyParams.show_days">
                        <div class="col-md-auto" *ngFor="let d of days">
                            <div class="input-group flex-nowrap">
                                <div class="input-group-prepend">
                                    <div class="input-group-text d-block p-1 border-0 bg-white">
                                        <input type="checkbox" aria-label="Checkbox for days" [(ngModel)]="strategyParams.days[d]">
                                    </div>
                                </div>
                                <span class="input-group-text flex-nowrap p-1 border-0 bg-white" id="">{{ d }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label class="form-label">&nbsp;</label>
                        </div>
                    </div>
                </div> -->
                <!-- <div *ngIf="strategyParams.code == 'ml_v1_2'">
                    Not Implemented Yet
                </div> -->
                <div class="modal-footer">
                    <button class="btn btn-sm btn-danger px-5 shadow-none" (click)="cancelEditSettingsPopup(strategyParams)">
                        Cancel
                    </button>
                    <button class="btn btn-sm btn-success px-5 shadow-none" (click)="saveEditSettingsPopup($event, strategyParams)">
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
